import { useEffect, useState } from "react";
import { LAYER_TYPE, Layer } from "../actions/Layers/constants";
import useConfig from "../actions/Tenants/config/configHook";
import { useSwitchTabContext } from "../components/scenes/Layers/fields/switchTabContext";
import { getFilledArrayOrDefault } from "../utils";

export const useDefaultLayer = (): [Layer, React.Dispatch<React.SetStateAction<Layer>>] => {
    const config = useConfig();
    // * Outside the overview this falls back to the default filter, so no tab-derived type is applied.
    const { filter } = useSwitchTabContext();
    const [layer, setLayer] = useState<Layer>({
        label: "",
        type: LAYER_TYPE.PALLET
    } as any);

    // * Temporary disable fruit type detection by mini
    // const selected_mini = useSelector((state) => state.devices.selected_mini);
    // const fruitType = selected_mini && !config.can_do_manual_check ? selected_mini.fruit_type : config.default_fruit_type;

    // * Find default fruit_type from root_config
    const rootDefaultFruitType = config.root_config?.default_fruit_type;

    // * Find default_value from fruit_type in meta_form (Edit Layer Form)
    const layer_config = config.get_raw_layer_config(layer.type);
    const defaultFruitTypes = getFilledArrayOrDefault(layer_config?.meta_form).filter((x) => x.name === "fruit_type" && x.default_value).map((x) => x.default_value);

    // * Set default value from root_config, or edit_layer_form or from hardcoded config (Legacy feature, was for most set to avocado)
    const fruitType = rootDefaultFruitType || defaultFruitTypes?.[0] || config.default_fruit_type;

    const fruitConfig = config.get_fruit_type(fruitType);

    useEffect(() => {
        const defaultLayer: Layer = {
            fruit_type: fruitType,
            fruit_variety: fruitConfig.default_variety,
        } as Layer;
        setLayer((prev) => ({ ...prev, ...defaultLayer }));

    }, [fruitType, fruitConfig.default_variety]);

    useEffect(() => {
        const stage = config.get_stage(filter.location);

        // * if we explicitly set a default create layer type
        if (stage && stage?.default_create_layer_type) {
            setLayer((prev) => ({ ...prev, type: stage.default_create_layer_type }));
        // * else default to the layer type we are viewing
        } else if (filter.layer_type) {
            setLayer((prev) => ({ ...prev, type: filter.layer_type as LAYER_TYPE }));
        }

    }, [filter.layer_type, filter.location]);

    return [layer, setLayer];
};
